import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "\n      menu\n      menu-sub\n      menu-sub-dropdown\n      menu-column\n      menu-rounded\n      menu-gray-600\n      menu-state-bg-light-primary\n      fw-bold\n      py-4\n      fs-6\n      w-275px\n    ",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/logo.png"
  })
], -1)
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_8 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_9 = { class: "menu-title position-relative" }
const _hoisted_10 = { class: "\n              fs-8\n              rounded\n              bg-light\n              px-3\n              py-2\n              position-absolute\n              translate-middle-y\n              top-50\n              end-0\n            " }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "symbol symbol-20px me-4" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "menu-item px-5 my-1" }
const _hoisted_17 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$store.state.AuthModule.user.agent), 1)
        ])
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.$t("UserMenu.Language")) + " ", 1),
            _createElementVNode("span", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t("Languages." + _ctx.currentLangugeLocale.code)) + " ", 1),
              _createElementVNode("img", {
                class: "w-15px h-15px rounded-1 ms-2",
                src: _ctx.currentLangugeLocale.flag,
                alt: "metronic"
              }, null, 8, _hoisted_11)
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "menu-item px-3",
            key: country.name
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.setLang(country.code)),
              href: "#",
              class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage(country.code) }])
            }, [
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("img", {
                  class: "rounded-1",
                  src: country.flag,
                  alt: "metronic"
                }, null, 8, _hoisted_15)
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Languages." + country.code)), 1)
            ], 10, _hoisted_13)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_router_link, {
        to: "/account-settings",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("UserMenu.Settings")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.$t("UserMenu.Logout")), 1)
    ])
  ]))
}